function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTimerGreen = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 30 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M10.032,2.088L10.032,-0.2L19.186,-0.2L19.186,2.088L10.032,2.088ZM13.464,19.137L15.753,19.137L15.753,10.365L13.464,10.365L13.464,19.137ZM14.609,31.8C12.727,31.8 10.954,31.438 9.288,30.713C7.623,29.988 6.167,29.003 4.921,27.757C3.675,26.511 2.69,25.055 1.965,23.39C1.24,21.725 0.878,19.951 0.878,18.069C0.878,16.188 1.24,14.414 1.965,12.749C2.69,11.083 3.675,9.628 4.921,8.382C6.167,7.136 7.623,6.15 9.288,5.426C10.954,4.701 12.727,4.339 14.609,4.339C16.312,4.339 17.914,4.625 19.414,5.197C20.915,5.769 22.25,6.564 23.419,7.581L25.364,5.636L26.966,7.237L25.021,9.183C25.936,10.2 26.718,11.433 27.367,12.882C28.015,14.332 28.339,16.061 28.339,18.069C28.339,19.951 27.977,21.725 27.252,23.39C26.528,25.055 25.542,26.511 24.296,27.757C23.05,29.003 21.595,29.988 19.929,30.713C18.264,31.438 16.49,31.8 14.609,31.8ZM14.609,29.512C17.787,29.512 20.489,28.399 22.714,26.174C24.938,23.949 26.051,21.248 26.051,18.069C26.051,14.891 24.938,12.189 22.714,9.964C20.489,7.74 17.787,6.627 14.609,6.627C11.43,6.627 8.729,7.74 6.504,9.964C4.279,12.189 3.166,14.891 3.166,18.069C3.166,21.248 4.279,23.949 6.504,26.174C8.729,28.399 11.43,29.512 14.609,29.512Z",
    style: {
      fill: "#2fa400",
      fillRule: "nonzero"
    }
  }));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTimerGreen);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/timer-green.9960b8586b7196aea6e3364c28e80a9e.svg";